import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
interface AuthState {
  accessToken: string | null;
  customFieldId: string;
  environment: "Demo" | "Test";
}

// initial states
const initialState: AuthState = {
  accessToken: null,
  customFieldId: "bd1833d0-c1eb-11ef-85d5-e5b1b2e5df91",
  environment:
    (localStorage.getItem("environment") as "Demo" | "Test") || "Demo",
};

const reducers = {
  setAccessToken: (state: AuthState, action: PayloadAction<string | null>) => {
    state.accessToken = action.payload;
  },
  setEnvironment: (
    state: AuthState,
    action: PayloadAction<"Demo" | "Test">
  ) => {
    state.environment = action.payload;
    localStorage.setItem("environment", action.payload);
  },
};

// creating auth slice
const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers,
});

// exporting actions
export const { setAccessToken, setEnvironment } = AuthSlice.actions;

export default AuthSlice.reducer;
